module.exports = __webpack_public_path__ + "fwm_h5/img/xuexiaofu.28cc0df8.png";